import { callFunction } from '@/commands/callFunction'

/**
 * Gestion des référentiels d'administration.
 *
 * Chaque référentiel expose trois actions nommées côté serveur (`createTool`,
 * `updateTool`, `deleteTool`, ...). Ce module se contente de les appeler : aucune
 * validation métier n'est rejouée ici, et le client n'écrit jamais dans Firestore.
 *
 * Les champs acceptés sont déclarés côté serveur ; envoyer une clé inconnue est refusé.
 */
const ENTITIES = [
  'bonus', 'building', 'communication', 'contact', 'contractStatus', 'contractType',
  'dataList', 'depot', 'depotArea', 'hrStatus', 'invoiceCompany', 'job', 'message',
  'offer', 'period', 'resultBonus', 'skill', 'staffType', 'stuff', 'stuffType',
  'supplier', 'team', 'template', 'tool', 'toolType', 'training',
]

const catalogueCommands = {}

for (const entity of ENTITIES) {
  const capitalized = entity.charAt(0).toUpperCase() + entity.slice(1)

  catalogueCommands[entity] = {
    /** Crée une entrée. L'identifiant est facultatif : le serveur en génère un sinon. */
    create(data, id = null) {
      return callFunction(`create${capitalized}`, id ? { data, id } : { data })
    },
    /** Met à jour les champs transmis, en laissant les autres inchangés. */
    update(id, data) {
      return callFunction(`update${capitalized}`, { id, data })
    },
    /** Supprime l'entrée et nettoie ses dépendances dans les états. */
    delete(id) {
      return callFunction(`delete${capitalized}`, { id })
    },
  }
}

export default catalogueCommands
